import type { LibraryBlock } from "../build";
import {
  BLACK_GLASS,
  CARD_SHADOW,
  ellipse,
  icon,
  logo,
  motion,
  photo,
  pill,
  rect,
  SHADOW,
  type TemplateNode,
  text,
  WHITE,
} from "./helpers";

export const LOWER_THIRDS: LibraryBlock[] = [
  {
    id: "bb-name-rolle",
    title: "Name & Rolle",
    category: "bauchbinde",
    width: 780,
    height: 176,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({ x: 0, y: 0, w: 16, h: 176, fill: "accent", name: "Akzent", ...motion("fly-right") }),
      rect({
        x: 16,
        y: 0,
        w: 764,
        h: 176,
        fill: "background/95",
        name: "Fläche",
        ...motion("slide-right", { delay: 80 }),
      }),
      text({
        text: "Maxi Mustermann",
        style: "heading-2",
        size: 56,
        color: "text",
        x: 56,
        y: 30,
        w: 690,
        ...motion("slide-up", { delay: 260, duration: 450 }),
      }),
      text({
        text: "Gründerin & Geschäftsführerin",
        style: "subline",
        size: 32,
        color: "text-muted",
        x: 56,
        y: 104,
        w: 690,
        ...motion("slide-up", { delay: 380, duration: 450 }),
      }),
    ],
  },
  {
    id: "bb-farbbalken",
    title: "Farbbalken",
    category: "bauchbinde",
    width: 760,
    height: 190,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({ x: 0, y: 0, w: 720, h: 108, fill: "primary", name: "Balken", ...motion("fly-right") }),
      text({
        text: "Maxi Mustermann",
        style: "heading-2",
        size: 58,
        color: "on:primary",
        x: 36,
        y: 0,
        w: 660,
        h: 108,
        ...motion("fly-right", { delay: 60 }),
      }),
      rect({
        x: 0,
        y: 118,
        w: 500,
        h: 68,
        fill: "accent",
        name: "Balken klein",
        ...motion("fly-right", { delay: 180 }),
      }),
      text({
        text: "Leitung Marketing",
        style: "subline",
        size: 32,
        color: "on:accent",
        x: 36,
        y: 118,
        w: 440,
        h: 68,
        ...motion("fly-right", { delay: 240 }),
      }),
    ],
  },
  {
    id: "bb-portrait",
    title: "Mit Porträt",
    category: "bauchbinde",
    width: 800,
    height: 170,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 800,
        h: 170,
        fill: "background",
        radius: "full",
        name: "Pille",
        shadow: { color: "#00000033", y: 10, blur: 40 },
        ...motion("pop"),
      }),
      photo({
        x: 14,
        y: 14,
        w: 142,
        h: 142,
        ellipse: true,
        name: "Porträt",
        ...motion("zoom", { delay: 150 }),
      }),
      text({
        text: "Alex Beispiel",
        style: "heading-2",
        size: 50,
        color: "text",
        x: 186,
        y: 30,
        w: 560,
        ...motion("slide-left", { delay: 250, duration: 450 }),
      }),
      text({
        text: "Projektleitung",
        style: "subline",
        size: 30,
        color: "primary",
        x: 186,
        y: 96,
        w: 560,
        ...motion("slide-left", { delay: 350, duration: 450 }),
      }),
    ],
  },
  {
    id: "bb-minimal",
    title: "Minimal mit Linie",
    category: "bauchbinde",
    width: 820,
    height: 180,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      text({
        text: "Sam Beispiel",
        style: "heading-1",
        size: 66,
        color: WHITE,
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 820,
        ...motion("slide-up"),
      }),
      {
        kind: "shape",
        shape: "line",
        x: 0,
        y: 96,
        w: 240,
        h: 18,
        stroke: { color: "accent", width: 6 },
        name: "Linie",
        ...motion("fly-right", { delay: 200 }),
      },
      text({
        text: "Expertin für Nachhaltigkeit",
        style: "subline",
        size: 34,
        color: "#ffffffdd",
        shadow: SHADOW,
        x: 0,
        y: 126,
        w: 820,
        ...motion("fade", { delay: 380 }),
      }),
    ],
  },
  {
    id: "bb-social",
    title: "Social-Handle",
    category: "bauchbinde",
    width: 620,
    height: 110,
    anchor: "lower-third",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 620,
        h: 110,
        fill: "#000000b3",
        radius: "full",
        name: "Pille",
        ...motion("slide-right"),
      }),
      ellipse({
        x: 12,
        y: 12,
        w: 86,
        h: 86,
        fill: "accent",
        name: "Kreis",
        ...motion("spin", { delay: 150 }),
      }),
      text({
        text: "@",
        style: "heading-1",
        size: 50,
        color: "on:accent",
        x: 12,
        y: 12,
        w: 86,
        h: 80,
        align: "center",
        ...motion("spin", { delay: 150 }),
      }),
      text({
        text: "deinname",
        style: "heading-2",
        size: 46,
        color: WHITE,
        x: 124,
        y: 0,
        w: 470,
        h: 110,
        ...motion("slide-right", { delay: 250 }),
      }),
    ],
  },
  {
    id: "bb-kapitel",
    title: "Kapitel",
    category: "bauchbinde",
    width: 800,
    height: 190,
    anchor: "lower-third",
    duration: 4500,
    nodes: [
      ...pill(0, 0, 250, 60, "KAPITEL 2", "accent", 26, motion("pop")),
      rect({
        x: 0,
        y: 76,
        w: 800,
        h: 114,
        fill: "#000000b3",
        radius: "sm",
        name: "Fläche",
        ...motion("slide-up", { delay: 150 }),
      }),
      text({
        text: "Die ersten Schritte",
        style: "heading-2",
        size: 58,
        color: WHITE,
        x: 36,
        y: 76,
        w: 728,
        h: 114,
        ...motion("slide-up", { delay: 250 }),
      }),
    ],
  },
  {
    id: "bb-ort",
    title: "Ort & Datum",
    category: "bauchbinde",
    width: 700,
    height: 150,
    anchor: "lower-third",
    duration: 4500,
    nodes: [
      rect({ x: 0, y: 0, w: 10, h: 150, fill: "primary", name: "Akzent", ...motion("slide-down") }),
      text({
        text: "HAMBURG",
        style: "heading-1",
        size: 64,
        color: WHITE,
        shadow: SHADOW,
        x: 34,
        y: 4,
        w: 660,
        ...motion("slide-right", { delay: 120 }),
      }),
      text({
        text: "12. Juni · Hafencity",
        style: "subline",
        size: 34,
        color: "#ffffffdd",
        shadow: SHADOW,
        x: 34,
        y: 90,
        w: 660,
        ...motion("slide-right", { delay: 260 }),
      }),
    ],
  },
  {
    id: "bb-interview",
    title: "Zwei Personen",
    category: "bauchbinde",
    tags: ["Interview", "Podcast", "Gespräch", "Gast"],
    width: 960,
    height: 150,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      ...[
        { x: 0, name: "Maxi Mustermann", role: "Moderation", bar: "accent", move: "slide-right" },
        {
          x: 490,
          name: "Alex Beispiel",
          role: "Gast · Bäckermeister",
          bar: "primary",
          move: "slide-left",
        },
      ].flatMap((person, index): TemplateNode[] => {
        const delay = index * 300;
        const move = person.move as "slide-right" | "slide-left";
        return [
          rect({
            x: person.x,
            y: 0,
            w: 470,
            h: 150,
            fill: "background/95",
            radius: "md",
            name: "Fläche",
            ...motion(move, { delay }),
          }),
          rect({
            x: person.x,
            y: 0,
            w: 12,
            h: 150,
            fill: person.bar,
            name: "Akzent",
            ...motion(move, { delay }),
          }),
          text({
            text: person.name,
            style: "heading-2",
            size: 42,
            color: "text",
            x: person.x + 38,
            y: 26,
            w: 410,
            ...motion("fade", { delay: delay + 200 }),
          }),
          text({
            text: person.role,
            style: "subline",
            size: 28,
            color: "text-muted",
            x: person.x + 38,
            y: 88,
            w: 410,
            ...motion("fade", { delay: delay + 300 }),
          }),
        ];
      }),
    ],
  },
  {
    id: "bb-kanal",
    title: "Kanal mit Logo",
    category: "bauchbinde",
    tags: ["Logo", "Channel", "YouTube", "Marke"],
    width: 800,
    height: 150,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 800,
        h: 150,
        fill: "background",
        radius: "md",
        shadow: CARD_SHADOW,
        name: "Fläche",
        ...motion("slide-right", { delay: 120 }),
      }),
      rect({
        x: 0,
        y: 0,
        w: 230,
        h: 150,
        fill: "primary",
        radius: "md",
        name: "Logo-Fläche",
        ...motion("pop"),
      }),
      logo({ x: 25, y: 25, w: 180, h: 100, on: "primary", align: "center", ...motion("pop") }),
      text({
        text: "Dein Kanal",
        style: "heading-2",
        size: 46,
        color: "text",
        x: 262,
        y: 24,
        w: 510,
        ...motion("slide-right", { delay: 300 }),
      }),
      text({
        text: "Neue Folge jeden Freitag",
        style: "subline",
        size: 28,
        color: "text-muted",
        x: 262,
        y: 90,
        w: 510,
        ...motion("slide-right", { delay: 400 }),
      }),
    ],
  },
  {
    id: "bb-gestapelt",
    title: "Gestapelt",
    category: "bauchbinde",
    tags: ["Titel", "Expertin", "Name"],
    width: 760,
    height: 250,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      ...pill(0, 0, 250, 56, "EXPERTIN", "accent", 24, motion("pop")),
      rect({
        x: 0,
        y: 70,
        w: 760,
        h: 100,
        fill: "primary",
        name: "Balken",
        ...motion("fly-right", { delay: 150 }),
      }),
      text({
        text: "Dr. Lena Schulz",
        style: "heading-2",
        size: 54,
        color: "on:primary",
        x: 32,
        y: 70,
        w: 700,
        h: 100,
        ...motion("fly-right", { delay: 200 }),
      }),
      rect({
        x: 0,
        y: 180,
        w: 560,
        h: 70,
        fill: "background/95",
        name: "Balken klein",
        ...motion("fly-right", { delay: 320 }),
      }),
      text({
        text: "Ernährungsberaterin",
        style: "subline",
        size: 30,
        color: "text",
        x: 32,
        y: 180,
        w: 500,
        h: 70,
        ...motion("fly-right", { delay: 370 }),
      }),
    ],
  },
  {
    id: "bb-glas",
    title: "Glas",
    category: "bauchbinde",
    tags: ["transparent", "Milchglas", "modern"],
    width: 780,
    height: 170,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 780,
        h: 170,
        fill: "#ffffff2e",
        stroke: { color: "#ffffff66", width: 2 },
        radius: "lg",
        name: "Glas",
        ...motion("blur", { duration: 600 }),
      }),
      text({
        text: "Jonas Keller",
        style: "heading-2",
        size: 56,
        color: WHITE,
        shadow: SHADOW,
        x: 44,
        y: 26,
        w: 700,
        ...motion("slide-up", { delay: 200 }),
      }),
      text({
        text: "Fotograf · Hamburg",
        style: "subline",
        size: 30,
        color: "#ffffffd9",
        shadow: SHADOW,
        x: 44,
        y: 104,
        w: 700,
        ...motion("slide-up", { delay: 320 }),
      }),
    ],
  },
  {
    id: "bb-news",
    title: "Nachrichten-Stil",
    category: "bauchbinde",
    tags: ["News", "Ticker", "Thema", "Breaking"],
    width: 960,
    height: 146,
    anchor: "lower-third",
    duration: 6000,
    nodes: [
      rect({ x: 0, y: 0, w: 220, h: 90, fill: "accent", name: "Thema", ...motion("pop") }),
      text({
        text: "THEMA",
        style: "subline",
        size: 32,
        color: "on:accent",
        x: 20,
        y: 0,
        w: 180,
        h: 90,
        align: "center",
        ...motion("pop"),
      }),
      rect({
        x: 220,
        y: 0,
        w: 740,
        h: 90,
        fill: "primary",
        name: "Balken",
        ...motion("fly-right", { delay: 120 }),
      }),
      text({
        text: "Neue Radwege in der Innenstadt",
        style: "heading-2",
        size: 40,
        color: "on:primary",
        x: 250,
        y: 0,
        w: 690,
        h: 90,
        ...motion("fly-right", { delay: 180 }),
      }),
      rect({
        x: 0,
        y: 90,
        w: 960,
        h: 56,
        fill: BLACK_GLASS,
        name: "Zeile",
        ...motion("slide-down", { delay: 350 }),
      }),
      text({
        text: "Heute, 18 Uhr · Rathausplatz",
        style: "subline",
        size: 26,
        color: WHITE,
        x: 30,
        y: 90,
        w: 900,
        h: 56,
        ...motion("slide-down", { delay: 400 }),
      }),
    ],
  },
  {
    id: "bb-ort-pin",
    title: "Ort mit Pin",
    category: "bauchbinde",
    tags: ["Ort", "Location", "Standort", "Adresse", "Karte"],
    width: 720,
    height: 150,
    anchor: "lower-third",
    duration: 4500,
    nodes: [
      ellipse({ x: 0, y: 15, w: 120, h: 120, fill: "accent", name: "Kreis", ...motion("pop") }),
      icon({
        icon: "map-pin",
        x: 25,
        y: 40,
        w: 70,
        h: 70,
        color: "on:accent",
        name: "Pin",
        ...motion("drop", { delay: 150, duration: 700 }),
      }),
      text({
        text: "Café Sonnenschein",
        style: "heading-2",
        size: 54,
        color: WHITE,
        shadow: SHADOW,
        x: 150,
        y: 14,
        w: 570,
        ...motion("slide-right", { delay: 250 }),
      }),
      text({
        text: "Leipzig · Südvorstadt",
        style: "subline",
        size: 32,
        color: "#ffffffdd",
        shadow: SHADOW,
        x: 150,
        y: 90,
        w: 570,
        ...motion("slide-right", { delay: 380 }),
      }),
    ],
  },
  {
    id: "bb-umrandet",
    title: "Umrandet",
    category: "bauchbinde",
    tags: ["Rahmen", "Kontur", "Name"],
    width: 760,
    height: 200,
    anchor: "lower-third",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 760,
        h: 160,
        stroke: { color: WHITE, width: 4 },
        radius: "sm",
        name: "Rahmen",
        ...motion("zoom"),
      }),
      text({
        text: "Mia Hoffmann",
        style: "heading-2",
        size: 58,
        color: WHITE,
        shadow: SHADOW,
        x: 36,
        y: 0,
        w: 688,
        h: 130,
        ...motion("fade", { delay: 200 }),
      }),
      ...pill(36, 130, 320, 64, "Fotografin", "accent", 28, motion("pop", { delay: 350 })),
    ],
  },
];
